import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import styled, { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { shape, object, string, number, arrayOf, bool } from 'prop-types';
import createTheme from './createTheme';
const BaseContainer = styled.div`
  font-family: ${props => props.theme.fontFamily};
  line-height: ${props => props.theme.lineHeights.standard}px;
  font-weight: ${props => props.theme.fontWeights.regular};

  ${({
  globalResets = true
}) => globalResets && `
      * {
        margin: 0;
        padding: 0;
        outline: 0;
        box-sizing: border-box;
      }

      body {
        margin: 0;
      }
    `}
`;

const ThemeProvider = _ref => {
  let {
    theme
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["theme"]);

  const mergedTheme = createTheme(theme);
  return /*#__PURE__*/React.createElement(StyledThemeProvider, {
    theme: mergedTheme
  }, /*#__PURE__*/React.createElement(BaseContainer, props));
};

process.env.NODE_ENV !== "production" ? ThemeProvider.propTypes = {
  theme: shape({
    fontFamily: string,
    fontSizes: arrayOf(number),
    color: object,
    palette: object
  }),
  globalResets: bool
} : void 0;
ThemeProvider.defaultProps = {
  theme: {},
  globalResets: true
};
export default ThemeProvider;